// Ghi nhớ phiếu vừa xem để phân biệt "mở phiếu MỚI" với "tải lại phiếu ĐANG xem".
//
// Vì sao cần: nhánh refreshMode 'allPage' tải lại bằng cách bật route sang /reload rồi
// quay về — màn phiếu bị tháo ra dựng lại từ đầu, không còn nhớ gì. Nếu không có sổ này
// thì mỗi lần đóng phiếu (hoặc phiếu khai 'allPage') sẽ loé nguyên khung xám, trong khi
// người dùng vẫn đang ở đúng phiếu đó.

var WINDOW_MS = 5000;
var lastView = { key: null, at: 0 };

function now() {
    return new Date().getTime();
}

export function markVoucherViewed(key) {
    if (!key) return;
    lastView = { key: String(key), at: now() };
}

export function shouldShowBootSkeleton(key) {
    if (!key) return false;
    if (lastView.key === String(key) && now() - lastView.at < WINDOW_MS) return false;
    return true;
}

export function bootKeyOf(params) {
    if (!params) return null;
    var key = params.code || params.id;
    return key ? String(key) : null;
}
